export const GET_SOURCES = 'GET_SOURCES';
export const GET_SOURCE_BY_ID = 'GET_SOURCE_BY_ID';
export const UPDATE_SOURCE = 'UPDATE_SOURCE';
export const DELETE_SOURCE = 'DELETE_SOURCE';
export const CREATE_SOURCE = 'CREATE_SOURCE';
